import CommentIconButton from "components/Cells/CommentIconButton";
import { func, object, shape } from "prop-types";
import { useSelector } from "react-redux";
import { buildItemRefKey, selectCountsMap } from "slices/comments";

const OUTLINE_SECTION_SURFACE = "OUTLINE_SECTION";

const CommentCell = ({ row, onComment }) => {
  const { id } = row.original;
  const countsMap = useSelector(selectCountsMap(OUTLINE_SECTION_SURFACE, id));
  const commentCount =
    countsMap[buildItemRefKey(OUTLINE_SECTION_SURFACE, { outlineItemId: id })] ??
    0;

  return (
    <CommentIconButton
      commentCount={commentCount}
      onClick={(event) => {
        event.stopPropagation();
        onComment(id, event.currentTarget);
      }}
    />
  );
};

CommentCell.propTypes = {
  onComment: func.isRequired,
  row: shape({ original: object }).isRequired,
};

export default CommentCell;
